import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/SignIn.css';

const normalizePlan = (plan) => {
  if (!plan) return null;
  const p = plan.toLowerCase();
  if (p.includes('basic') || p.includes('explor')) return 'basic';
  if (p.includes('premium') || p.includes('navigat')) return 'premium';
  if (p.includes('enterprise') || p.includes('pathfinder') || p.includes('pionnier')) return 'enterprise';
  return null;
};

const SignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login, loading } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [showPw, setShowPw] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = await login(formData.email, formData.password);
      const plan = normalizePlan(user?.plan || user?.accessLevel);
      if (plan === 'basic') navigate('/basic-dashboard');
      else if (plan === 'premium') navigate('/premium-dashboard');
      else if (plan === 'enterprise') navigate('/enterprise-dashboard');
      else navigate('/plans');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-wrapper">
        <div className="signin-brand">
          <span>🕌</span>
          <span>{t('app_name')}</span>
        </div>
        <h2>{t('signin_welcome')}</h2>
        <p>{t('signin_welcome_desc')}</p>
        {error && <div className="error-message">⚠️ {error}</div>}
        <form onSubmit={handleSubmit} className="signin-form">
          <div className="form-group">
            <label>{t('email')}</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder={t('signin_email_placeholder')} required />
          </div>
          <div className="form-group">
            <label>{t('password')}</label>
            <div className="signin-pw-wrap">
              <input type={showPw ? 'text' : 'password'} name="password" value={formData.password} onChange={handleChange} placeholder={t('signin_password_placeholder')} required />
              <button type="button" className="signin-pw-toggle" onClick={() => setShowPw(v => !v)}>{showPw ? '🙈' : '👁️'}</button>
            </div>
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? t('signing_in') : t('signin_button')}
          </button>
        </form>
        <p className="signup-link">
          {t('signin_no_account')}{' '}<Link to="/plans">{t('signin_signup_link')}</Link>
        </p>
      </div>
    </div>
  );
};

export default SignIn;
